module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/spice-market@2x_aa39c7.jpg";